import type { Translate } from '../../i18n';

/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ The week strip's two labels. One definition, three callers.               │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * ⚠️⚠️ **THIS WAS ALREADY DUPLICATED BEFORE C27.2 NEEDED IT A THIRD TIME.** `time-screen.tsx` and
 * `logs-screen.tsx` each carried their own identical `dowLabel`; the agent's overview card would have
 * been the third copy. `hard-won.md`'s warning about a copied predicate is about exactly this shape —
 * and the failure here is quiet rather than loud: two screens disagreeing about which day of the week
 * a column is, in one locale only, after somebody fixes a Monday-first bug in one of them.
 *
 * ⚠️ **Monday first, which is the mockup's `DOW` order and the week `WorklogService.overview`
 * returns.** The strip's index and the array's index are the same thing, and they have to be.
 */

/** `HÉT` … `VAS`, by index from Monday. */
export function dowLabel(t: Translate, index: number): string {
  /* ⚠️ One `t()` call per branch with a LITERAL key. `t(DOW_KEYS[i])` is invisible to `i18n:check`,
   * which reads literal arguments only — every day would report as an orphan. */
  switch (index) {
    case 0:
      return t('time.dow.mon');
    case 1:
      return t('time.dow.tue');
    case 2:
      return t('time.dow.wed');
    case 3:
      return t('time.dow.thu');
    case 4:
      return t('time.dow.fri');
    case 5:
      return t('time.dow.sat');
    default:
      return t('time.dow.sun');
  }
}

/**
 * `2026-08-17` → `17.`, which is what the strip shows under the weekday.
 *
 * ⚠️ **Read out of the WIRE DATE rather than through a `Date`.** `hard-won.md`'s driver rows: a
 * calendar date parsed as an instant lands on the previous day for part of every evening, and this
 * number is the one a person matches against their own calendar.
 */
export function dayOfMonth(date: string): string {
  return `${String(Number(date.slice(8)))}.`;
}
